export default `
mutation SendUnsubscribeRequest($serviceProviderId: ID!, $userId: ID!) {
  sendUnsubscribeRequest(serviceProviderId: $serviceProviderId, userId: $userId) {
    void
  }
}
`;
